// Age-adaptive educational content for SpeelSlim.
// Everything is config-driven so AI-generated lessons can be added later
// by pushing new lesson objects with the same shape.

export const FRUIT = ["🍎", "🍌", "🍊", "🍓", "🍇", "🍉", "🍒", "🥝"];
export const ANIMALS = ["🐶", "🐱", "🦊", "🐼", "🐧", "🐰", "🐸", "🦁", "🐵", "🐷"];
export const COLORS = ["🔴", "🔵", "🟡", "🟢", "🟣", "🟠"];
export const COLOR_NAMES = { "🔴": "rood", "🔵": "blauw", "🟡": "geel", "🟢": "groen", "🟣": "paars", "🟠": "oranje" };

// ---- Wereld (aardrijkskunde) ----
export const FLAGS = [
  { flag: "🇳🇱", country: "Nederland" }, { flag: "🇧🇪", country: "België" },
  { flag: "🇫🇷", country: "Frankrijk" }, { flag: "🇩🇪", country: "Duitsland" },
  { flag: "🇪🇸", country: "Spanje" }, { flag: "🇮🇹", country: "Italië" },
  { flag: "🇬🇧", country: "Engeland" }, { flag: "🇺🇸", country: "Amerika" },
  { flag: "🇯🇵", country: "Japan" }, { flag: "🇧🇷", country: "Brazilië" },
];

// ---- Creativiteit: kleuren mengen ----
export const COLORMIX = [
  { a: "🔴", b: "🟡", r: "🟠" }, // rood + geel = oranje
  { a: "🔵", b: "🟡", r: "🟢" }, // blauw + geel = groen
  { a: "🔴", b: "🔵", r: "🟣" }, // rood + blauw = paars
];

// ---- Classify datasets (wetenschap, dieren, wereld) ----
export const CLASSIFY = {
  continent: {
    prompt: "Uit welk werelddeel komt dit dier?",
    categories: ["Afrika", "Azië", "Australië", "Zuidpool", "Europa"],
    data: [
      { item: "🦁", cat: "Afrika" }, { item: "🐘", cat: "Afrika" }, { item: "🦒", cat: "Afrika" },
      { item: "🐼", cat: "Azië" }, { item: "🐯", cat: "Azië" },
      { item: "🦘", cat: "Australië" }, { item: "🐨", cat: "Australië" },
      { item: "🐧", cat: "Zuidpool" }, { item: "🦭", cat: "Zuidpool" },
      { item: "🦊", cat: "Europa" }, { item: "🦌", cat: "Europa" },
    ],
  },
  living: {
    prompt: "Is dit een dier of een plant?",
    categories: ["Dier", "Plant"],
    data: [
      { item: "🐶", cat: "Dier" }, { item: "🐱", cat: "Dier" }, { item: "🐦", cat: "Dier" }, { item: "🐠", cat: "Dier" }, { item: "🐝", cat: "Dier" },
      { item: "🌻", cat: "Plant" }, { item: "🌳", cat: "Plant" }, { item: "🌵", cat: "Plant" }, { item: "🌹", cat: "Plant" }, { item: "🍀", cat: "Plant" },
    ],
  },
  float: {
    prompt: "Drijft het of zinkt het?",
    categories: ["Drijft", "Zinkt"],
    data: [
      { item: "🍃", cat: "Drijft" }, { item: "🦆", cat: "Drijft" }, { item: "🛟", cat: "Drijft" }, { item: "🍎", cat: "Drijft" }, { item: "⛵", cat: "Drijft" },
      { item: "🪨", cat: "Zinkt" }, { item: "🔑", cat: "Zinkt" }, { item: "⚓", cat: "Zinkt" }, { item: "🧱", cat: "Zinkt" }, { item: "🔨", cat: "Zinkt" },
    ],
  },
  habitat: {
    prompt: "Waar woont dit dier?",
    categories: ["Boerderij", "Jungle", "Zee", "Pool"],
    data: [
      { item: "🐄", cat: "Boerderij" }, { item: "🐷", cat: "Boerderij" }, { item: "🐔", cat: "Boerderij" },
      { item: "🦁", cat: "Jungle" }, { item: "🐒", cat: "Jungle" }, { item: "🐍", cat: "Jungle" },
      { item: "🐠", cat: "Zee" }, { item: "🐙", cat: "Zee" }, { item: "🦈", cat: "Zee" },
      { item: "🐧", cat: "Pool" }, { item: "🐻‍❄️", cat: "Pool" },
    ],
  },
};

export const WORDS = [
  // lvl 1 — kort & makkelijk (3-5 jaar)
  { word: "appel", emoji: "🍎", lvl: 1 }, { word: "hond", emoji: "🐶", lvl: 1 },
  { word: "kat", emoji: "🐱", lvl: 1 }, { word: "zon", emoji: "☀️", lvl: 1 },
  { word: "boom", emoji: "🌳", lvl: 1 }, { word: "bal", emoji: "⚽", lvl: 1 },
  { word: "vis", emoji: "🐟", lvl: 1 }, { word: "maan", emoji: "🌙", lvl: 1 },
  { word: "ster", emoji: "⭐", lvl: 1 }, { word: "huis", emoji: "🏠", lvl: 1 },
  { word: "auto", emoji: "🚗", lvl: 1 }, { word: "koe", emoji: "🐄", lvl: 1 },
  { word: "aap", emoji: "🐵", lvl: 1 }, { word: "ei", emoji: "🥚", lvl: 1 },
  // lvl 2 — middel (6-8 jaar)
  { word: "bloem", emoji: "🌸", lvl: 2 }, { word: "taart", emoji: "🎂", lvl: 2 },
  { word: "boot", emoji: "⛵", lvl: 2 }, { word: "beer", emoji: "🐻", lvl: 2 },
  { word: "banaan", emoji: "🍌", lvl: 2 }, { word: "wortel", emoji: "🥕", lvl: 2 },
  { word: "trein", emoji: "🚂", lvl: 2 }, { word: "raket", emoji: "🚀", lvl: 2 },
  { word: "kasteel", emoji: "🏰", lvl: 2 }, { word: "olifant", emoji: "🐘", lvl: 2 },
  // lvl 3 — moeilijk & lang (9-12 jaar)
  { word: "vlinder", emoji: "🦋", lvl: 3 }, { word: "krokodil", emoji: "🐊", lvl: 3 },
  { word: "dinosaurus", emoji: "🦕", lvl: 3 }, { word: "helikopter", emoji: "🚁", lvl: 3 },
  { word: "aardbei", emoji: "🍓", lvl: 3 }, { word: "regenboog", emoji: "🌈", lvl: 3 },
  { word: "paraplu", emoji: "☂️", lvl: 3 }, { word: "pinguïn", emoji: "🐧", lvl: 3 },
];

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

// ---- helpers ----
export const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
export const shuffle = (arr) => [...arr].sort(() => Math.random() - 0.5);
export const sample = (arr, n) => shuffle(arr).slice(0, n);
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

function makeOptions(answer, poolMin, poolMax, count) {
  const opts = new Set([answer]);
  let guard = 0;
  while (opts.size < count && guard < 100) {
    opts.add(randInt(poolMin, poolMax));
    guard++;
  }
  return shuffle([...opts]);
}

// ---- difficulty tiers by age ----
// Number range for sums (result) and counting scales smoothly per age:
// age 3 -> ~5, age 12 -> ~50 for sums.
const SUM_MAX_BY_AGE = { 3: 5, 4: 8, 5: 10, 6: 12, 7: 15, 8: 20, 9: 25, 10: 30, 11: 40, 12: 50 };
const COUNT_MAX_BY_AGE = { 3: 5, 4: 6, 5: 8, 6: 10, 7: 12, 8: 15, 9: 18, 10: 20, 11: 20, 12: 20 };

function tier(age) {
  const a = Math.min(12, Math.max(3, age | 0));
  const base = a <= 4 ? { options: 3, patternColors: 2, memoryPairs: 3, letterOptions: 3 }
    : a <= 6 ? { options: 3, patternColors: 3, memoryPairs: 4, letterOptions: 4 }
    : a <= 8 ? { options: 4, patternColors: 3, memoryPairs: 6, letterOptions: 5 }
    : { options: 4, patternColors: 4, memoryPairs: 8, letterOptions: 6 };
  return { maxCount: COUNT_MAX_BY_AGE[a], sumMax: SUM_MAX_BY_AGE[a], ...base };
}

// More practice for older kids: 5 sums at age 3 up to ~14 at age 12.
function roundsFor(type, age) {
  const a = Math.min(12, Math.max(3, age | 0));
  if (type === "sum" || type === "count") return 5 + (a - 3);
  if (type === "quiz") return a <= 5 ? 5 : a <= 8 ? 6 : 8;
  return ROUNDS;
}

// ---- AI quiz fallback bank (used when AI is slow/offline) ----
export const QUIZ_FALLBACK = {
  taal: [
    { question: "Wat is het tegenovergestelde van 'groot'?", options: ["klein", "hoog", "snel"], answer: "klein" },
    { question: "Welk woord rijmt op 'huis'?", options: ["muis", "boom", "kat"], answer: "muis" },
    { question: "Wat is het meervoud van 'kind'?", options: ["kinderen", "kindes", "kinds"], answer: "kinderen" },
    { question: "Welk woord betekent hetzelfde als 'blij'?", options: ["vrolijk", "boos", "moe"], answer: "vrolijk" },
  ],
  wereld: [
    { question: "Wat is de hoofdstad van Nederland?", options: ["Amsterdam", "Parijs", "Berlijn"], answer: "Amsterdam" },
    { question: "Op welk werelddeel wonen pinguïns in het wild?", options: ["Zuidpool", "Afrika", "Europa"], answer: "Zuidpool" },
    { question: "Welke kleur heeft de zee meestal?", options: ["blauw", "rood", "geel"], answer: "blauw" },
    { question: "Hoeveel werelddelen zijn er?", options: ["7", "3", "12"], answer: "7" },
  ],
  wetenschap: [
    { question: "Wat hebben planten nodig om te groeien?", options: ["zonlicht", "snoep", "muziek"], answer: "zonlicht" },
    { question: "Hoeveel poten heeft een spin?", options: ["8", "6", "4"], answer: "8" },
    { question: "Wat komt er uit een wolk als het regent?", options: ["water", "zand", "melk"], answer: "water" },
    { question: "Welk zintuig gebruik je om te ruiken?", options: ["neus", "oor", "hand"], answer: "neus" },
  ],
  logica: [
    { question: "Welk getal komt hierna? 2, 4, 6, ...", options: ["8", "7", "9"], answer: "8" },
    { question: "Appel, banaan, druif. Wat past er niet bij? Auto of peer?", options: ["auto", "peer"], answer: "auto" },
    { question: "Wat is zwaarder: 1 kilo veren of 1 kilo steen?", options: ["allebei even zwaar", "de steen", "de veren"], answer: "allebei even zwaar" },
    { question: "Welke vorm heeft geen hoeken?", options: ["cirkel", "vierkant", "driehoek"], answer: "cirkel" },
  ],
  dieren: [
    { question: "Wat eet een konijn het liefst?", options: ["wortels", "vlees", "vis"], answer: "wortels" },
    { question: "Welk dier zegt 'boe'?", options: ["koe", "hond", "kat"], answer: "koe" },
    { question: "Waar woont een vis?", options: ["in het water", "in een boom", "in een hol"], answer: "in het water" },
    { question: "Hoe heet een jonge hond?", options: ["puppy", "kalf", "veulen"], answer: "puppy" },
  ],
  rekenen: [
    { question: "Jij hebt 3 appels en krijgt er 2 bij. Hoeveel heb je nu?", options: ["5", "4", "6"], answer: "5" },
    { question: "Er zitten 6 snoepjes in een zak. Je eet er 2 op. Hoeveel blijven er over?", options: ["4", "3", "5"], answer: "4" },
    { question: "In de klas zitten 2 rijen van 5 kinderen. Hoeveel kinderen zijn dat?", options: ["10", "7", "12"], answer: "10" },
    { question: "Een taart wordt in 8 stukken gesneden. Er zijn er 3 op. Hoeveel stukken zijn er nog?", options: ["5", "4", "6"], answer: "5" },
  ],
};

// ---- subject / lesson catalog ----
export const SUBJECTS = [
  {
    id: "rekenen", title: "Rekenen", emoji: "🔢", color: "#38BDF8", colorDark: "#0284C7",
    unlocked: true,
    lessons: [
      { id: "tellen", title: "Tellen", type: "count", icon: "🍎", intro: "Tel de appels en kies het juiste getal!" },
      { id: "sommen", title: "Sommen", type: "sum", icon: "➕", intro: "Los de som op. Jij kan het!" },
      { id: "verhaaltjes", title: "Verhaaltjessommen", type: "quiz", ai: true, skill: "rekenen", icon: "🧮", intro: "Lees het verhaaltje en kies het juiste antwoord!" },
    ],
  },
  {
    id: "taal", title: "Taal", emoji: "📚", color: "#F472B6", colorDark: "#DB2777",
    unlocked: true,
    lessons: [
      { id: "letters", title: "Letters", type: "letter", icon: "🔤", intro: "Luister goed en tik de juiste letter aan!" },
      { id: "woorden", title: "Woorden", type: "word", icon: "💬", intro: "Luister naar het woord en kies het plaatje!" },
      { id: "woordkennis", title: "Woordkennis", type: "quiz", ai: true, skill: "taal", icon: "🧠", intro: "Slimme taalvragen. Kies het juiste antwoord!" },
    ],
  },
  {
    id: "logica", title: "Logica", emoji: "🧩", color: "#4ADE80", colorDark: "#16A34A",
    unlocked: true,
    lessons: [
      { id: "patronen", title: "Patronen", type: "pattern", icon: "🔺", intro: "Wat komt er hierna? Maak het patroon af!" },
      { id: "geheugen", title: "Geheugen", type: "memory", icon: "🃏", intro: "Vind de dezelfde dieren. Onthoud goed!" },
      { id: "raadsels", title: "Raadsels", type: "quiz", ai: true, skill: "logica", icon: "💡", intro: "Denk goed na en los het raadsel op!" },
    ],
  },
  {
    id: "wereld", title: "Wereld", emoji: "🌍", color: "#FB923C", colorDark: "#EA580C",
    unlocked: true,
    lessons: [
      { id: "vlaggen", title: "Vlaggen", type: "flag", icon: "🚩", intro: "Bekijk de vlag en kies het juiste land!" },
      { id: "werelddelen", title: "Werelddelen", type: "continent", icon: "🗺️", intro: "Uit welk werelddeel komt het dier?" },
      { id: "aardrijkskunde", title: "Aardrijkskunde", type: "quiz", ai: true, skill: "wereld", icon: "🧭", intro: "Ontdek de wereld! Kies het juiste antwoord." },
    ],
  },
  {
    id: "creativiteit", title: "Creativiteit", emoji: "🎨", color: "#A78BFA", colorDark: "#7C3AED",
    unlocked: true,
    lessons: [
      { id: "kleuren-mengen", title: "Kleuren mengen", type: "colormix", icon: "🎨", intro: "Welke kleur krijg je als je twee kleuren mengt?" },
      { id: "tekenen", title: "Tekenen", type: "draw", icon: "🖍️", intro: "Teken je eigen kunstwerk! Kies een kleur en begin." },
    ],
  },
  {
    id: "wetenschap", title: "Wetenschap", emoji: "🔬", color: "#22D3EE", colorDark: "#0891B2",
    unlocked: true,
    lessons: [
      { id: "dier-plant", title: "Dier of plant?", type: "living", icon: "🌱", intro: "Is het een dier of een plant? Tik op het juiste vakje!" },
      { id: "drijft-zinkt", title: "Drijft of zinkt?", type: "float", icon: "💧", intro: "Denk goed na: drijft het of zinkt het in water?" },
      { id: "weetjes", title: "Weetjes", type: "quiz", ai: true, skill: "wetenschap", icon: "🔭", intro: "Slimme weetjes over natuur en wetenschap!" },
    ],
  },
  {
    id: "muziek", title: "Muziek", emoji: "🎵", color: "#FDE047", colorDark: "#EAB308",
    unlocked: true,
    lessons: [
      { id: "naspelen", title: "Naspelen", type: "music-play", icon: "🎹", intro: "Luister goed naar de melodie en speel hem na!" },
      { id: "vrij-spelen", title: "Vrij spelen", type: "music-free", icon: "🎶", intro: "Maak je eigen muziek op de kleurige toetsen!" },
    ],
  },
  {
    id: "dieren", title: "Dieren", emoji: "🐶", color: "#FBBF24", colorDark: "#D97706",
    unlocked: true,
    lessons: [
      { id: "waar-woont", title: "Waar woont het?", type: "habitat", icon: "🏡", intro: "Waar woont dit dier? Kies de juiste plek!" },
      { id: "dieren-geheugen", title: "Geheugen", type: "memory", icon: "🐾", intro: "Vind de dezelfde dieren!" },
      { id: "dieren-quiz", title: "Dierenquiz", type: "quiz", ai: true, skill: "dieren", icon: "🦉", intro: "Hoeveel weet jij over dieren? Kies het juiste antwoord!" },
    ],
  },
];

export function getSubject(id) { return SUBJECTS.find((s) => s.id === id); }
export function getLesson(subjectId, lessonId) {
  const s = getSubject(subjectId);
  return s ? s.lessons.find((l) => l.id === lessonId) : null;
}

const ROUNDS = 5;

// ---- round generators ----
export function generateRounds(type, age) {
  const t = tier(age);
  switch (type) {
    case "count":
      return Array.from({ length: roundsFor("count", age) }, () => {
        const count = randInt(1, t.maxCount);
        const emoji = pick([...FRUIT, ...ANIMALS]);
        return { kind: "count", emoji, count, answer: count,
                 options: makeOptions(count, Math.max(1, count - 2), count + 2, t.options),
                 prompt: "Hoeveel zie je?" };
      });

    case "sum":
      return Array.from({ length: roundsFor("sum", age) }, () => {
        const visual = age <= 7; // young kids see the objects, older kids only numbers
        let a, b, answer, op;
        if (age >= 10 && Math.random() < 0.5) {
          op = "×"; a = randInt(2, 10); b = randInt(2, 10); answer = a * b;
        } else {
          op = "+";
          a = randInt(1, Math.max(2, Math.floor(t.sumMax / 2)));
          b = randInt(1, Math.max(1, t.sumMax - a));
          answer = a + b;
        }
        const spread = Math.max(3, Math.round(answer * 0.2));
        return { kind: "sum", a, b, op, answer, visual, emoji: pick(FRUIT),
                 options: makeOptions(answer, Math.max(0, answer - spread), answer + spread, t.options),
                 prompt: `${a} ${op} ${b} = ?` };
      });

    case "letter":
      return Array.from({ length: ROUNDS }, () => {
        const target = pick(ALPHABET);
        const opts = new Set([target]);
        while (opts.size < t.letterOptions) opts.add(pick(ALPHABET));
        return { kind: "letter", target, options: shuffle([...opts]),
                 prompt: `Zoek de letter ${target}` };
      });

    case "word":
      return Array.from({ length: ROUNDS }, () => {
        const correct = pick(WORDS);
        const distractors = sample(WORDS.filter((w) => w.word !== correct.word), t.options - 1);
        return { kind: "word", word: correct.word, answer: correct.emoji,
                 options: shuffle([correct, ...distractors]),
                 prompt: `Welk plaatje is: ${correct.word}?` };
      });

    case "pattern":
      return Array.from({ length: ROUNDS }, () => {
        const palette = sample(COLORS, t.patternColors);
        const unit = age <= 4 ? 2 : (age <= 8 ? palette.length : palette.length);
        const base = Array.from({ length: unit }, (_, i) => palette[i % palette.length]);
        const reps = 2;
        const seq = [];
        for (let r = 0; r < reps; r++) seq.push(...base);
        const answer = base[seq.length % base.length];
        const display = [...seq, "❓"];
        const opts = shuffle([...new Set([answer, ...sample(COLORS, t.options)])]).slice(0, t.options);
        if (!opts.includes(answer)) opts[0] = answer;
        return { kind: "pattern", display, answer, options: shuffle(opts),
                 prompt: "Wat komt hierna?" };
      });

    case "memory": {
      const chosen = sample(ANIMALS, tier(age).memoryPairs);
      return [{ kind: "memory", pairs: chosen, prompt: "Vind de paren!" }];
    }

    case "color":
      return Array.from({ length: ROUNDS }, () => {
        const opts = sample(COLORS, tier(age).options);
        const answer = pick(opts);
        return { kind: "color", answer, colorName: COLOR_NAMES[answer],
                 options: shuffle(opts), prompt: `Welke kleur is ${COLOR_NAMES[answer]}?` };
      });

    case "flag":
      return Array.from({ length: ROUNDS }, () => {
        const c = pick(FLAGS);
        const opts = new Set([c.country]);
        while (opts.size < tier(age).options) opts.add(pick(FLAGS).country);
        return { kind: "flag", flag: c.flag, answer: c.country,
                 options: shuffle([...opts]), prompt: "Welk land is dit?" };
      });

    case "colormix":
      return Array.from({ length: ROUNDS }, () => {
        const m = pick(COLORMIX);
        const opts = new Set([m.r]);
        while (opts.size < tier(age).options) opts.add(pick(COLORS));
        return { kind: "colormix", a: m.a, b: m.b, answer: m.r,
                 options: shuffle([...opts]), prompt: "Welke kleur krijg je?" };
      });

    case "continent":
    case "living":
    case "float":
    case "habitat": {
      const cfg = CLASSIFY[type];
      const t = tier(age);
      const optCount = Math.min(Math.max(t.options, 2), cfg.categories.length);
      return Array.from({ length: ROUNDS }, () => {
        const it = pick(cfg.data);
        const cats = new Set([it.cat]);
        while (cats.size < optCount) cats.add(pick(cfg.categories));
        return { kind: "classify", item: it.item, answer: it.cat,
                 options: shuffle([...cats]), prompt: cfg.prompt };
      });
    }

    default:
      return [];
  }
}

// Offline/fallback quiz rounds when AI is unavailable.
export function quizFallbackRounds(skill, age) {
  const bank = QUIZ_FALLBACK[skill] || QUIZ_FALLBACK.taal;
  const n = roundsFor("quiz", age);
  const chosen = sample(bank, Math.min(n, bank.length));
  return chosen.map((q) => ({
    kind: "quiz", question: q.question, prompt: q.question,
    options: shuffle(q.options), answer: q.answer, explanation: q.explanation || "",
  }));
}

export function quizRoundCount(age) { return roundsFor("quiz", age); }

// ---- daily challenges ----
export const DAILY_CHALLENGES = [
  { id: "three_lessons", text: "Speel 3 lessen", goal: 3, metric: "lessons", reward: { coins: 30, diamonds: 1 } },
  { id: "ten_sums", text: "Los 10 sommen op", goal: 10, metric: "sums", reward: { coins: 25 } },
  { id: "five_words", text: "Lees 5 woorden", goal: 5, metric: "words", reward: { coins: 20 } },
];

// ---- achievements catalog (labels in Dutch) ----
export const ACHIEVEMENTS = {
  eerste_les: { title: "Eerste les!", icon: "🎉", desc: "Je hebt je eerste les gespeeld" },
  vijf_lessen: { title: "Vijf lessen", icon: "🏅", desc: "5 lessen voltooid" },
  tien_lessen: { title: "Tien lessen", icon: "🏆", desc: "10 lessen voltooid" },
  streak_3: { title: "3 dagen reeks", icon: "🔥", desc: "3 dagen achter elkaar geleerd" },
  streak_7: { title: "Weekheld", icon: "⭐", desc: "7 dagen achter elkaar geleerd" },
  streak_30: { title: "Superster", icon: "👑", desc: "30 dagen achter elkaar geleerd" },
};

// ---- pets ----
export const PETS = [
  { kind: "fox", name: "Vos", emoji: "🦊" },
  { kind: "cat", name: "Kat", emoji: "🐱" },
  { kind: "dog", name: "Hond", emoji: "🐶" },
  { kind: "panda", name: "Panda", emoji: "🐼" },
  { kind: "penguin", name: "Pinguïn", emoji: "🐧" },
  { kind: "dragon", name: "Draak", emoji: "🐲" },
  { kind: "unicorn", name: "Eenhoorn", emoji: "🦄" },
  { kind: "rabbit", name: "Konijn", emoji: "🐰" },
  { kind: "lion", name: "Leeuw", emoji: "🦁" },
  { kind: "frog", name: "Kikker", emoji: "🐸" },
  { kind: "owl", name: "Uil", emoji: "🦉" },
  { kind: "monkey", name: "Aap", emoji: "🐵" },
];

// Cosmetic accessories the child can buy and equip on the pet.
export const PET_ACCESSORIES = [
  { id: "🎩", name: "Hoge hoed", price: 30 },
  { id: "🧢", name: "Pet", price: 20 },
  { id: "👑", name: "Kroon", price: 50 },
  { id: "👓", name: "Bril", price: 25 },
  { id: "🎀", name: "Strik", price: 20 },
  { id: "🕶️", name: "Zonnebril", price: 30 },
  { id: "🎓", name: "Baret", price: 35 },
  { id: "🧣", name: "Sjaal", price: 25 },
  { id: "⭐", name: "Ster", price: 40 },
  { id: "🌸", name: "Bloem", price: 15 },
];
